import { css } from 'lit';

export default css`
    .view {
        display: flex;
        flex-direction: column;
        height: 100%;
        background-color: var(--color-surface-secondary);
        padding: var(--metrics-spacing-s);
        overflow: auto;
    }

    ki-ds-pwa-timeseries-list {
        flex: 1;
        width: 100%;
        max-width: var(--size-px--500px, 500px);
        margin-inline: auto;
    }
`;
